__turbopack_context__.v({
  "highlightPulse": "PostComments-module-scss-module__yYwV1W__highlightPulse",
  "input": "PostComments-module-scss-module__yYwV1W__input",
  "list": "PostComments-module-scss-module__yYwV1W__list",
  "root": "PostComments-module-scss-module__yYwV1W__root",
  "title": "PostComments-module-scss-module__yYwV1W__title",
});
